import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'clsx';
import css from "./spinner.module.css";
// Fresh components implementation. Solely for the loading state of the buttons until
// the loading animation is in Pantry
export const Spinner = ({ id, className, size, testHook, }) => {
    const classes = classNames(css.spinner, className);
    return (_jsx("svg", { className: classes, viewBox: "0 0 66 66", "data-testhook": testHook, width: size, height: size, id: id, children: _jsx("circle", { className: css.path, cx: "33", cy: "33", r: "30", fill: "none", strokeWidth: "5", strokeLinecap: "round" }) }));
};
